import * as PIXI from 'pixi.js';
import Point from 'Utility/Point';
import CleanupManager from '../../Utility/CleanupManager';
import Renderable from '../Renderable';

export type Mask = PIXI.Sprite | PIXI.Graphics | null;
export default class MaskComponent extends Renderable {
    private readonly cleanupManager: CleanupManager = new CleanupManager();

    public onUpdate(gameObject: GameObject<PIXI.Container>, container: PIXI.Container, params: any) {
        super.onUpdate(gameObject, container, params);
        if (typeof params.mask !== "undefined") {
            this.setMask(params.mask);
        }
    }

    public onAttach(gameObject: GameObject<PIXI.Container>, container: PIXI.Container, params: any) {
        super.onAttach(gameObject, container, params);
        this.setMask(params.mask);
    }

    public onDetach() {
        this.cleanupManager.cleanUpAll();
    }

    public set maskCacheKey(maskCacheKey: string) {
        const mask = PIXI.Sprite.fromImage(maskCacheKey);
        this.setMask(mask);
    }

    public set pivot(value: Point) {
        this.container.mask.pivot = value
    }

    public get pivot(): Point {
        return this.container.mask?.pivot;
    }

    public set anchor(value: Point) {
        if (this.container.mask instanceof PIXI.Sprite) {
            this.container.mask.anchor.copy(value);
        }
    }

    public get anchor(): Point {
        if (this.container.mask instanceof PIXI.Sprite) {
            return this.container.mask?.anchor;
        }
    }

    public setMask(mask: Mask): void {
        // Check specified mask is valid type.
        if (mask === null || !this.isMaskType(mask)) return;

        // Check mask changed.
        if (mask === this.container.mask) return;

        this.cleanupManager.cleanUpAll();
        this.container.addChild(mask);
        this.container.mask = mask;
        this.cleanupManager.add(() => {
            this.container.mask = null;
        });
    }

    private isMaskType(mask: unknown): mask is Mask {
        return (mask instanceof PIXI.Sprite) || (mask instanceof PIXI.Graphics)
    }
}
